var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.2266 8.77342L3.52843 12.8355C3.68993 13.0236 3.97704 13.0612 4.15649 12.8919C4.33594 12.7227 4.37183 12.4218 4.21033 12.2337L1.14178 8.45372C1.15972 8.45372 1.17767 8.47252 1.19561 8.47252L15.5514 8.47252C15.8026 8.47252 16 8.26566 16 8.00237C16 7.73909 15.8026 7.53223 15.5514 7.53223L1.21356 7.53223C1.19561 7.53223 1.17767 7.55103 1.15973 7.55103L4.22827 3.77104C4.38977 3.56418 4.37183 3.28209 4.17444 3.11284C4.08471 3.03761 3.99499 3 3.88732 3C3.76171 3 3.6361 3.05642 3.54637 3.16925L0.244545 7.23133C-0.0784607 7.60745 -0.0784607 8.3973 0.2266 8.77342Z",
    fill: "#001411"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.c5a9af5518c6450bf02a0c0e18aa237b.svg";
export { ForwardRef as ReactComponent };